import { Component, OnInit } from '@angular/core';
import { HomeComponent } from './../home/home.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: 'app-aux-url-inf-ter',
  templateUrl: './aux-url-inf-ter.component.html',
  styleUrls: ['./aux-url-inf-ter.component.css']
})
export class AuxUrlInfTerComponent implements OnInit {

  public mapasUrl = GLOBAL.mapasUrl;
  public acotado = GLOBAL.acotado;

  constructor(private dialog: MatDialog, private _router: Router) { }

  ngOnInit() {
  }



}




